module.exports = __webpack_public_path__ + "img/info.31c197df.svg";